<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="outselect" :inputflag="item.inputflag" :event="item.event"
						:selcoms="item.selcoms" :key="index" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Outboundreportmanagementtable ref="Outtable" :tableDataMD="tableDataMD" @onRowClick="onRowClick"
					@DespatchExport="DespatchExport" :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" @rowDetail="onRowClick"  >
				</Outboundreportmanagementtable>
			</div>
			<div class="TableBox"
				style=" margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
				<Outboundreportmanagement :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique">
				</Outboundreportmanagement>
			</div>

			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Outboundreportmanagementtable from './components/outboundreportmanagementtable.vue'
	import Outboundreportmanagement from './components/outboundreportmanagement-bottom.vue'

	import utils from '../../../common/utils'
	import {
		InventoryClassList,
		InventoryClassInfo,
		CusType,
		Status,
		wmsDespatchDetail,
		wmsDespatchDetailUnique,
	} from '@/api/home'

	import {
		ConsignOrderList,
		ConsignOrderDetail,
		ConsignOrderExport
	} from '@/api/newsapi'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Outboundreportmanagementtable,
			Outboundreportmanagement
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				dialogVisibles: false,
				tableDataDetail: [],
				tableDataUnique: [],
				tableDataMD: [],
				type: 0,
				wtype: 1,
				formdata: [{
						inputdata: '',
						title: '上报方名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '95px',
						inputflag: false
					},
					{
						inputdata: '',
						title: '单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px',
						options: [],
						selcoms: false,
					},
					{
						inputdata: '',
						title: '寄售方向',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '95px',
						options: [{
							key: 1,
							value: '寄售退'
						}, {
							key: 0,
							value: '寄售出'
						}],
					},
					{
						inputdata: "",
						title: "寄售日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '寄售公司',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '190px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '95px',
						options: [],
					},

					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '200px',
						lablewith: '100px',
						options: [],
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '266px',
						lablewith: '135px'
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '150px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '300px',
						lablewith: '125px'
					}
				],
				comid: '',
				fromdatalist: [],
				loading: true,
				from: {
					CreateOrgName: "",
					COCode: "",
					ReturnFlag: "",
					HPName: "",
					CODate1: "",
					CODate2: "",
					Status: "",
					InvClass: "",
					CreateTime1: "",
					CreateTime2: "",
					VerifyTime1: "",
					VerifyTime2: "",
					Inventory: "",
					Batch: "",
				}
			}
		},
		mounted() {
			this.cusType()
			this.status()
			this.inventoryClassList()
			this.ConsignOrderList()
		},
		methods: {
			// 列表
			async ConsignOrderList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await ConsignOrderList({
					CreateOrgName: this.from.CreateOrgName,
					COCode: this.from.COCode,
					ReturnFlag: this.from.ReturnFlag,
					HPName: this.from.HPName,
					CODate1: this.from.CODate1,
					CODate2: this.from.CODate2,
					Status: this.from.Status,
					InvClass: this.from.InvClass,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					VerifyTime1: this.from.VerifyTime1,
					VerifyTime2: this.from.VerifyTime2,
					Inventory: this.from.Inventory,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data.map(item => {
						item.CODate = item.CODate ? item.CODate.substring(0, 10) : '';
						return item;
					})
				}
				loading.close();
			},
			// 导出
			async wmsDespatchExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ConsignOrderExport({
					CreateOrgName: this.from.CreateOrgName,
					COCode: this.from.COCode,
					ReturnFlag: this.from.ReturnFlag,
					HPName: this.from.HPName,
					CODate1: this.from.CODate1,
					CODate2: this.from.CODate2,
					Status: this.from.Status,
					InvClass: this.from.InvClass,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					VerifyTime1: this.from.VerifyTime1,
					VerifyTime2: this.from.VerifyTime2,
					Inventory: this.from.Inventory,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					utils.downloadFile(resexprot, "寄售订单" + date.getTime(), "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close();
			},
			DespatchExport() {
				this.wmsDespatchExport()
			},
			onRowClick(val) {
				if (val.COMID) {
					this.comid = val.COMID
					this.ConsignOrderDetail()
					//this.wmsDespatchDetailUnique()
				}
			},
			// 明细
			async ConsignOrderDetail() {
				let {
					data,
					code
				} = await ConsignOrderDetail({
					comid: this.comid
				})
				if (code == 0) {
					this.tableDataDetail = data
					this.tableDataMD = data
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[6].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[6].options.push(obj)
					})
				}
			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			async cusType() {
				let {
					code,
					data
				} = await CusType({})
				if (code == 0) {
					if (data.CusType == "") {
						this.formdata[0].inputflag = true
					} else {
						this.formdata[0].inputflag = false
					}
				}
			},
			reset() {
				for (let index in this.$refs.outselect) {
					if (index == 3 || index == 8 || index == 9) {
						this.$refs.outselect[index].startTime = ''
						this.$refs.outselect[index].endTime = ''
					} else {
						this.$refs.outselect[index].modelvalue = ''
					}
				}
				this.ConsignOrderList()
			},
			cancel() {
				//console.log('name')
				this.dialogVisibles = false
			},
			dialogOK() {
				//console.log('name2')
				this.dialogVisibles = false
			},
			select() {
				// for (let item of this.formdata) {
				//   this.fromdatalist.push(item.inputdata)
				// }
				this.pageindex = 1
				try {
					this.from.CreateOrgName = this.$refs.outselect[0].modelvalue
					this.from.COCode = this.$refs.outselect[1].modelvalue
					this.from.ReturnFlag = this.$refs.outselect[2].modelvalue
					this.from.CODate1 = this.$refs.outselect[3].startTime
					this.from.CODate2 = this.$refs.outselect[3].endTime
					this.from.HPName = this.$refs.outselect[4].modelvalue
					this.from.Status = this.$refs.outselect[5].modelvalue
					this.from.InvClass = this.$refs.outselect[6].modelvalue
					this.from.Inventory = this.$refs.outselect[7].modelvalue
					this.from.CreateTime1 = this.$refs.outselect[8].startTime
					this.from.CreateTime2 = this.$refs.outselect[8].endTime
					this.from.VerifyTime1 = this.$refs.outselect[9].startTime
					this.from.VerifyTime2 = this.$refs.outselect[9].endTime
					this.from.Batch = this.$refs.outselect[10].modelvalue
					this.ConsignOrderList()
				} catch (error) {
					this.ConsignOrderList()
				}
			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.ConsignOrderList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.ConsignOrderList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.TableBox {
		margin-top: 10px;
		box-shadow: rgb(0 0 0 / 10%) 0px 1px 4px 0px;
		background-color: rgb(255, 255, 255);
	}

	.inputtop {
		width: 980px;
		height: 130px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 5px;
		width: 300px;
		height: 50px;
		background-color: #fff;
		position: relative;
		bottom: 140px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: -5px;
	}
</style>